import Config from '../config/general-config';
import baseService from './baseService';

const menuBoardService = () =>
  baseService.getRequest(Config.ENDPOINTS.MENU_BOARD);

export default menuBoardService;
